import React from 'react';
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "components/ui/card";
import { ArrowUpIcon, ArrowDownIcon } from "lucide-react";

export default function StatCard({ title, value, icon: Icon, trend, trendValue, bgColor = "bg-blue-500" }) {
  const { t } = useTranslation();
  const isPositive = trend === 'up';
  
  return (
    <Card className="relative overflow-hidden border-0 shadow-md hover:shadow-xl transition-all duration-300 bg-white">
      <div className={`absolute top-0 right-0 w-32 h-32 transform translate-x-12 -translate-y-12 ${bgColor} rounded-full opacity-5`} />
      <CardContent className="p-6">
        <div className="flex justify-between items-start mb-4">
          <div className="flex-1">
            <p className="text-sm font-medium text-slate-500 mb-1">{title}</p>
            <h3 className="text-3xl font-bold text-slate-900">{value}</h3>
          </div>
          <div className={`p-3 rounded-xl ${bgColor} bg-opacity-10`}>
            <Icon className={`w-6 h-6 ${bgColor.replace('bg-', 'text-')}`} />
          </div>
        </div>
        {trendValue && (
          <div className="flex items-center gap-2">
            {isPositive ? (
              <ArrowUpIcon className="w-4 h-4 text-green-500" />
            ) : (
              <ArrowDownIcon className="w-4 h-4 text-red-500" />
            )}
            <span className={`text-sm font-medium ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
              {trendValue}
            </span>
            <span className="text-sm text-slate-500">{t("dashboard.vsLastWeek")}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
